<template>
	<div>
		<!-- <b-form-input v-model="test" /> -->
		<!-- <filter-fields :filter-options.sync="filtersField" :column-count="4">
			<template #provinsi>
				<v-select
					v-model="selectedProvinsi"
					:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
					:options="provinsiOptions"
					class="w-100"
					label="nama"
					:reduce="val => val.kode"
					placeholder="Pilih Provinsi"
				/>
			</template>
			<template #kota>
				<v-select
					v-model="selectedKota"
					:dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
					:options="kotaOptions"
					class="w-100"
					label="nama"
					:reduce="val => val.kode"
					placeholder="Pilih Kota"
				/>
			</template>
		</filter-fields> -->
		<b-card>
			<own-table
				ref="orderTable"
				name-table="orders"
				:table-columns="columns"
				:disable-create-btn="true"
				:use-custom-filter="true"
				:custom-query-filter="queryFilter"
				@searchFieldOnChange="searchOnChange"
			>
				<template #cell(transaction)="data">
					<b-badge
						pill
						:variant="
							resolveInvoiceStatusVariantAndIcon(paymentStatus(data.data.item))
								.variant
						"
					>
						<feather-icon
							:icon="
								resolveInvoiceStatusVariantAndIcon(paymentStatus(data.data.item))
									.icon
							"
							size="14"
							class="mr-25"
						/>
						{{ paymentStatus(data.data.item) }}
					</b-badge>
				</template>
				<template #cell(shipping_status)="data">
					<b-badge
						pill
						:variant="shippingStatusVariant(shippingStatus(data.data.item))"
					>
						{{ shippingStatus(data.data.item) }}
					</b-badge>
				</template>
				<template #cell(transaction_date)="data">
					{{ formatDate(data.data.item.transaction.created_at) }}
				</template>
				<template #cell(actions)="data">
					<feather-icon
						:id="`branch-row-${data.data.item.no_invoice}-preview-icon`"
						icon="EyeIcon"
						size="16"
						class="mx-1"
						@click="
							() =>
								$router.push({
									name: 'order-detail',
									params: { id: data.data.item.id },
								})
						"
					/>
				</template>
			</own-table>
		</b-card>
	</div>
</template>
<script>
import {
	BCard,
	BFormInput,
	BBadge,
	BCardTitle,
} from 'bootstrap-vue'
import {
	ref,
	watch,
} from '@vue/composition-api'
import OwnTable from '@/components/Table/Table.vue'
import vSelect from 'vue-select'
import { formatDate, title } from '@core/utils/filter'
import useOrder from './useOrder'
// import FilterFields from '../components/filter/Filter.vue'
// import calonAgenStoreModule from './calonAgenStoreModule'

export default {
	components: {
		BCard,
		// FilterFields,
		OwnTable,
		BFormInput,
		vSelect,
		BBadge,
		BCardTitle,
	},
	setup() {
		// const CALON_AGEN_STORE_MODULE = 'calon-agen'
		// if (!store.hasModule(CALON_AGEN_STORE_MODULE)) {
		// 	store.registerModule(CALON_AGEN_STORE_MODULE, calonAgenStoreModule)
		// }
		// onUnmounted(() => {
		// 	store.unregisterModule(CALON_AGEN_STORE_MODULE)
		// })
		// const caloAgenTable = ref(null)
		// const regionAPiUrl = ref('https://permohonancustomer.ingco.co.id/public/api')

		const { resolveInvoiceStatusVariantAndIcon } = useOrder()
		const filtersField = ref([
			{
				key: 'provinsi',
				type: 'select',
				model: null,
				opitons: [],
			},
			{
				key: 'kota',
				type: 'select',
				model: null,
				opitons: [],
			},
			{
				key: 'from_date',
				type: 'date',
				model: null,
			},
			{
				key: 'to_date',
				type: 'date',
				model: null,
			},
		])
		const columns = ref([
			{
				label: 'No. Transaksi',
				key: 'transaction.no_invoice',
			},
			{
				label: 'Tgl. Transaksi',
				key: 'transaction_date',
				sortable: true,
				formatter: val => formatDate(val),
			},
			{
				label: 'Metode Bayar',
				key: 'transaction.type',
				sortable: true,
				formatter: val => title(val, '_'),
			},
			{
				label: 'Status Pembayaran',
				key: 'transaction',
				sortable: true,
			},
			{
				label: 'Status Pengiriman',
				key: 'shipping_status',
				sortable: true,
			},
			{
				label: 'Actions',
				key: 'actions',
			},
		])
		const queryFilter = ref('')
		const provinsiOptions = ref([])
		const selectedProvinsi = ref(null)
		const kotaOptions = ref([])
		const selectedKota = ref(null)
		const search = ref('')

		watch(
			[
				...filtersField.value.map(field => () => field.model),
				selectedProvinsi,
				selectedKota,
			],
			(newValue, prevValue) => {
				console.log(newValue)
				if (newValue[4] !== prevValue[4]) {
					selectedKota.value = null
					// eslint-disable-next-line prefer-destructuring
					filtersField.value.find(x => x.key === 'provinsi').model = newValue[4]
					fetchKota(newValue[4])
				}
				if (newValue[5] !== prevValue[5]) {
					// eslint-disable-next-line prefer-destructuring
					filtersField.value.find(x => x.key === 'kota').model = newValue[5]
				}
				queryFilter.value = filtersField.value
					.map(x => (x.model ? `&${x.key}=${x.model}` : ''))
					.join('')
					.concat(`${search.value !== '' ? `&q=${search.value}` : ''}`)
			},
		)
		const searchOnChange = val => {
			console.log(val)
			search.value = val
			queryFilter.value = filtersField.value
				.map(x => (x.model ? `&${x.key}=${x.model}` : ''))
				.join('')
				.concat(`${val !== '' ? `&q=${val}` : ''}`)
		}
		const paymentStatus = item =>
			item && item.transaction && item.transaction.status
				? item.transaction.status
				: '-'
		const shippingStatus = item => {
			if (!item) return '-'
			if (item.shipment && item.shipment.biteship_shipping_status) {
				return title(item.shipment.biteship_shipping_status, '_')
			}
			if (item.shipment && item.shipment.shipment_status) {
				return title(item.shipment.shipment_status, '_')
			}
			return item.status ? title(item.status, '_') : '-'
		}
		const shippingStatusVariant = status => {
			const normalized = `${status}`.toLowerCase()
			if (normalized.includes('deliver') || normalized.includes('finish')) return 'success'
			if (normalized.includes('process') || normalized.includes('confirm')) return 'info'
			if (normalized.includes('void') || normalized.includes('cancel')) return 'danger'
			if (normalized === '-' || normalized.includes('unconfirm')) return 'warning'
			return 'secondary'
		}

		return {
			filtersField,
			columns,
			queryFilter,
			provinsiOptions,
			selectedProvinsi,
			kotaOptions,
			selectedKota,
			searchOnChange,
			resolveInvoiceStatusVariantAndIcon,
			formatDate,
			paymentStatus,
			shippingStatus,
			shippingStatusVariant,
		}
	},
}
</script>
